import React from 'react';
import { connect } from 'react-redux'
import {  Container, Divider, Item, Label} from 'semantic-ui-react'
import ReactGA from 'react-ga';
import { fetchWinners } from '../../actions'
import Footer from '../footer/Footer';

class News extends React.Component {
  

  componentDidMount(){
        ReactGA.initialize('UA-137825974-1');
    
        ReactGA.pageview(window.location.pathname + window.location.search);    
  
      }

   
  renderNewsItems = () => {
   
   return this.props.winners.map( x => {
            return (
            <Item key={x.event_id}>
            <Item.Image src={x.event_winners} size='big'/>
            <Item.Content>
                <Item.Header as='a'>{x.event_calendardate}</Item.Header>
                <Item.Meta>
                    <span className='cinema'>{x.event_name}</span>
                </Item.Meta>
                <Item.Description>
                    {x.event_calendardate}
                </Item.Description>
                <Item.Extra>
                    <Label>Name:{x.event_name}</Label>
                    <Label>Location:{x.event_location}</Label>
                </Item.Extra>
            </Item.Content>
            </Item>
     ) });  
}
  
  render ()
  { 
    if(!this.props.winners){
        return <React.Fragment>
            <Container>
                <Divider hidden/>
                <h2>Latest regional news.</h2>
                <Item.Group divided>
                    Check back for News updates. 
                </Item.Group>
               
            </Container>
            <Footer/>
        </React.Fragment>
        
        }
    else{
        return (
                <React.Fragment>
                    <Container>
                        <Divider hidden/>
                        <h2>Latest regional winners.</h2>
                        <Item.Group divided>
                            {this.renderNewsItems()}
                        </Item.Group>
                    
                    </Container>
                    <Footer/>
                </React.Fragment>
                )
        }
    }
};  

const mapStateToProps = (state) => {
    return {winners: state.winners};
  }

export default connect(
    mapStateToProps,
    { fetchWinners }
  )(News);
